import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_9gmeb","loader":"button__loader_9gmeb","secondary":"button__secondary_9gmeb","text":"button__text_9gmeb","ghost":"button__ghost_9gmeb","component":"button__component_9gmeb","loading":"button__loading_9gmeb","outlined":"button__outlined_9gmeb","tertiary":"button__tertiary_9gmeb","transparent":"button__transparent_9gmeb","link":"button__link_9gmeb"};
require('./default.mobile.css')

var invertedColors = {"primary":"button__primary_41s56","loader":"button__loader_41s56","secondary":"button__secondary_41s56","text":"button__text_41s56","ghost":"button__ghost_41s56","component":"button__component_41s56","loading":"button__loading_41s56","outlined":"button__outlined_41s56","tertiary":"button__tertiary_41s56","transparent":"button__transparent_41s56","link":"button__link_41s56"};
require('./inverted.mobile.css')

var styles = {"size-32":"button__size-32_9myyv","size-40":"button__size-40_9myyv","size-48":"button__size-48_9myyv","size-56":"button__size-56_9myyv","size-64":"button__size-64_9myyv","size-72":"button__size-72_9myyv"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

export { ButtonMobile };
